/** Agent reasoning — speech-bubble chrome aligned with TaskThread agent messages. */

import { AgenticThoughtBlock } from "@/components/ui/agentic-thought-block";

interface ThoughtBubbleProps {
  children: React.ReactNode;
  agentName?: string;
}

export function ThoughtBubble({ children, agentName = "Agent" }: ThoughtBubbleProps) {
  return (
    <AgenticThoughtBlock agentName={agentName} title={agentName} collapsible={false}>
      {children}
    </AgenticThoughtBlock>
  );
}
